import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";

const DapLogo = () => (
  <div className="flex items-center gap-2">
    <div className="w-8 h-8 rounded-lg bg-[#CCFF00] flex items-center justify-center text-black font-display font-black text-lg">
      D
    </div>
    <span className="font-display font-black text-xl tracking-tight">DAP</span>
  </div>
);

export default function Nav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const onDashboard = loc.pathname.startsWith("/app") || loc.pathname === "/dashboard";

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-xl bg-[#0e0e0e]/70 border-b border-white/10"
      data-testid="dap-nav"
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-home-link">
          <DapLogo />
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-neutral-300">
          <Link to="/playbooks" className="hover:text-white" data-testid="nav-public-playbooks-link">
            Playbooks
          </Link>
          <Link to="/calculator" className="hover:text-white" data-testid="nav-calc-link">
            Rate Calculator
          </Link>
          <Link to="/scanner" className="hover:text-white" data-testid="nav-scanner-link">
            Contract Scanner
          </Link>
          <Link to="/billing" className="hover:text-white" data-testid="nav-pricing-link">
            Pricing
          </Link>
          {user && (
            <Link to="/app/inbox" className="hover:text-white" data-testid="nav-inbox-link">
              Inbox
            </Link>
          )}
          {user && (
            <Link to="/app/dashboard" className="hover:text-white" data-testid="nav-dashboard-link">
              Dashboard
            </Link>
          )}
        </nav>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              {user.plan === "free" && (
                <Link to="/billing" data-testid="nav-upgrade-link">
                  <Button
                    size="sm"
                    className="rounded-full bg-[#CCFF00] text-black hover:bg-[#b8e600] font-semibold hidden sm:inline-flex"
                  >
                    Upgrade
                  </Button>
                </Link>
              )}
              {user.plan !== "free" && (
                <span className="hidden sm:inline text-[10px] font-mono uppercase tracking-widest px-2 py-1 rounded bg-[#CCFF00] text-black">
                  {user.plan}
                </span>
              )}
              <span className="text-xs text-neutral-400 font-mono hidden sm:inline" data-testid="nav-user-handle">
                @{user.handle}
              </span>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => {
                  logout();
                  nav("/");
                }}
                data-testid="nav-logout-btn"
              >
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => nav("/login")}
                data-testid="nav-login-btn"
                className="text-neutral-300 hover:text-white"
              >
                Log in
              </Button>
              <Button
                size="sm"
                onClick={() => nav("/signup")}
                data-testid="nav-signup-btn"
                className="rounded-full bg-[#CCFF00] text-black hover:bg-[#b8e600]"
              >
                Get DAP →
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
